// Shared table/list controls. Keep search/filter state and action handlers in
// the owning page; this component only arranges them next to their dataset.
export default function DataToolbar({ children, actions, label = 'Alat tabel', className = '' }) {
  return <section aria-label={label} data-testid="data-toolbar" className={`flex min-w-0 flex-wrap items-center gap-3 rounded-xl border border-ui-line bg-ui-card p-3 ${className}`}>
    {children && <div data-slot="data-filters" className="flex min-w-0 flex-1 basis-64 flex-wrap items-center gap-2">{children}</div>}
    {actions && <div data-slot="data-actions" className="flex min-w-0 max-w-full flex-wrap items-center gap-2 [&>[data-testid=report-actions]]:my-0">{actions}</div>}
  </section>;
}
